import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { pickBy } from 'lodash';
import { BiContainer, BiProvider } from 'seagull';
import { useIoContext, useStore } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { selectors } from '~/store/state-selectors';
import { usePageViewTracking } from './usePageViewTracking/usePageViewTracking';
const BiPageTrackingProvider = (param)=>{
    let { children } = param;
    const [pageBiData, setPageBiData] = useState(undefined);
    usePageViewTracking({
        setPageBiData
    });
    return /*#__PURE__*/ _jsx(BiContainer, {
        name: pageBiData === null || pageBiData === void 0 ? void 0 : pageBiData.pageName,
        data: pageBiData === null || pageBiData === void 0 ? void 0 : pageBiData.pageEvent,
        children: children
    });
};
export const BiFrontendProvider = (param)=>{
    let { children } = param;
    const { logBIEvent: _logBIEvent, getNow } = useIoContext();
    const business_id = useStore(selectors.user.businessId);
    const user_id = useStore(selectors.user.id);
    const business_type = useStore(selectors.user.isVendor) ? 'service_provider' : 'client';
    const baseBiEventRef = useRef({});
    const ff = useFeatureFlags();
    const openedFeatureFlags = useMemo(()=>pickBy(ff), [
        ff
    ]);
    baseBiEventRef.current = {
        user_id,
        business_id,
        business_type,
        ff: openedFeatureFlags
    };
    const logBIEvent = useCallback((biEvent)=>{
        _logBIEvent(_object_spread({
            client_timestamp: getNow().toISOString()
        }, baseBiEventRef.current, biEvent));
    }, [
        _logBIEvent
    ]);
    return /*#__PURE__*/ _jsx(BiProvider, {
        logBi: logBIEvent,
        children: /*#__PURE__*/ _jsx(BiPageTrackingProvider, {
            children: children
        })
    });
};
